/* tslint:disable */
/* eslint-disable */
/**
 * Default API
 * All endpoints not defined under specific APIs
 *
 * The version of the OpenAPI document: Latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Election
 */
export interface Election {
  /**
   *
   * @type {number}
   * @memberof Election
   */
  vimeoAlbumId?: number;
  /**
   *
   * @type {number}
   * @memberof Election
   */
  year?: number;
  /**
   *
   * @type {string}
   * @memberof Election
   */
  label: string;
}

export function ElectionFromJSON(json: any): Election {
  return ElectionFromJSONTyped(json, false);
}

export function ElectionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Election {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    vimeoAlbumId: !exists(json, "vimeoAlbumId")
      ? undefined
      : json["vimeoAlbumId"],
    year: !exists(json, "year") ? undefined : json["year"],
    label: json["label"],
  };
}

export function ElectionToJSON(value?: Election | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    vimeoAlbumId: value.vimeoAlbumId,
    year: value.year,
    label: value.label,
  };
}
